var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1728,
    height: 1117,
    viewBox: "0 0 1728 1117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 1117,
    fill: "transparent"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 790.56,
    y: 336.532,
    width: 99.0018,
    height: 402.8,
    rx: 49.5009,
    transform: "rotate(16.212 790.56 336.532)",
    fill: "#F9595F",
    fillOpacity: 0.7,
    stroke: "white",
    strokeWidth: 1.61648
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 645.986,
    y: 389.127,
    width: 99.0018,
    height: 533.195,
    rx: 49.5009,
    transform: "rotate(-43 645.986 389.127)",
    fill: "#E066EB",
    fillOpacity: 0.7,
    stroke: "white",
    strokeWidth: 1.61648
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 943.89,
    y: 381.114,
    width: 99.0018,
    height: 402.8,
    rx: 49.5009,
    transform: "rotate(16.212 943.89 381.114)",
    fill: "#FFF705",
    fillOpacity: 0.7,
    stroke: "white",
    strokeWidth: 1.61648
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/LogoShort.4561ca3faa8cec3f076d94ee7cd140a3.svg";
export { ForwardRef as ReactComponent };